import { Box, Text } from '@factorialco/deprecated-design-system'

interface Props {
  term: string
  details: string
}

const ListPopoverItem = ({ term, details }: Props) => {
  return (
    <Box flexDirection="row" justifyContent="spaceBetween">
      <Text.Normal color="grey000White" size="200" weight="medium">
        {term}
      </Text.Normal>
      <Box textAlign="right">
        <Text.Normal color="grey000White" size="200" weight="semibold">
          {details}
        </Text.Normal>
      </Box>
    </Box>
  )
}

export default ListPopoverItem
